import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

const Input = ({ ...props }) => (
  <input styleName="input" maxLength="255" {...props} />
);

export default CSSModules(Input, css);
